export const useNameof = <T>() => {
	return (name: keyof T) => name;
};

/** Allows somewhat strong typing of an object's properties when accessing by string name */
export const nameof = <T>(name: keyof T) => name;
